import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import * as echarts from 'echarts'

interface Props {
  width?: string
  height?: string
  data: number[]
}

interface WrapperProps {
  height?: string
  width?: string
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: ${(props) => (props.height ? props.height : '100%')};
  width: ${(props) => (props.width ? props.width : '100%')};
  padding: 0;
  flex-shrink: 0;
`

export const MonthlyPVBarGraph = ({ width, height, data }: Props) => {
  const chartRef = useRef<echarts.ECharts | null>(null)
  const chartId = useRef(
    `monthly-pv-chart-${Math.floor(Math.random() * 1000000)}`
  )

  useEffect(() => {
    const chartDom = document.getElementById(chartId.current)
    if (!chartDom) return

    if (chartRef.current) {
      chartRef.current.dispose()
    }

    const chart = echarts.init(chartDom)
    const option: echarts.EChartsOption = {
      color: ['#4F8EF7'],
      tooltip: {
        trigger: 'axis',
        valueFormatter: (value) =>
          `${Number(value).toLocaleString(undefined, {
            maximumFractionDigits: 2,
          })} kWh`,
      },
      grid: {
        left: '4%',
        right: '4%',
        top: '8%',
        bottom: '5%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        axisTick: { show: false },
        data: Array.from({ length: 12 }, (_, index) => `${index + 1}월`),
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: '월별 발전량',
          type: 'bar',
          barMaxWidth: 28,
          data,
        },
      ],
    }

    chart.setOption(option)
    chartRef.current = chart
    requestAnimationFrame(() => chart.resize())

    return () => {
      chart.dispose()
      chartRef.current = null
    }
  }, [data])

  useEffect(() => {
    const handleResize = () => chartRef.current?.resize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Wrapper height={height} width={width}>
      <div id={chartId.current} style={{ height, width }} />
    </Wrapper>
  )
}
